import { createStore } from 'vuex';
import persistedStateVuex from 'persisted-state-vuex';
import { _integratedAxios } from '@/plugins/axios/integratedAxios';
import _ from 'lodash';

persistedStateVuex.config({
  storageKey: 'integratedVuex',
});

export default createStore({
  state: {
    teamList: [],
    managerList: [],
    connectionAdmin: [
      { value: 'ctm', text: 'CTM - Solutions' },
      { value: 'itm', text: 'ITM - Global' },
    ],
    countryCode: [],
    roadMapTypeList: [],
    memberInfo: {},
    accessToken: '',
    templateList: [],
    faqCategoryList: [],
  },
  getters: {
    /**
     * @description : 전체 포함
     */
    getAllCountryCode(state) {
      const cloneCountryCode = _.cloneDeep(state.countryCode);
      cloneCountryCode.unshift({
        value: '',
        text: '-전체-',
      });
      return cloneCountryCode;
    },
    /**
     * @description : 선택 포함
     */
    getCountryCode(state) {
      const cloneCountryCode = _.cloneDeep(state.countryCode);
      cloneCountryCode.unshift({
        value: '',
        text: '-선택-',
      });
      return cloneCountryCode;
    },
    /**
     * @description : 팀리스트 리턴
     * @returns : teamList
     */
    getTeamList(state) {
      return state.teamList;
    },
    /**
     * @description : 매니저리스트 리턴
     * @returns : teamList
     */
    getManagerList(state) {
      return state.managerList;
    },
    /**
     * @description : 연결관리자 리스트
     * @returns : connectionAdmin
     */
    getConnectionAdminList(state) {
      return state.connectionAdmin;
    },
    /**
     * @description : 토큰정보
     * @returns : tokenInfo
     */
    getTokenInfo(state) {
      return state.accessToken;
    },
    /**
     * @description : 사용자 정보
     * @returns : getMemberInfo
     */
    getMemberInfo(state) {
      return state.memberInfo;
    },
    /**
     * @description : 템플릿 리스트
     * @returns : templateList
     */
    getTemplateList(state) {
      return state.templateList;
    },
    /**
     * @description : 로드맵 타입 리스트
     * @returns : roadMapTypeList
     */
    getRoadMapTypeList(state) {
      return state.roadMapTypeList;
    },
    /**
     * @description : FAQ 카테고리 리스트
     * @returns : roadMapTypeList
     */
    getFaqCategoryList(state) {
      return state.faqCategoryList;
    },
  },
  mutations: {
    setAccessToken(state, payload) {
      state.accessToken = payload;
    },
    setMemberInfo(state, payload) {
      state.memberInfo = payload;
    },
    setManager(state, payload) {
      state.managerList = payload;
    },
    setTeamList(state, payload) {
      state.teamList = payload;
    },
    setTemplateList(state, payload) {
      state.templateList = payload;
    },
    setConnectionAdminList(state, payload) {
      state.connectionAdmin = payload;
    },
    setRoadMapTypeList(state, payload) {
      state.roadMapTypeList = payload;
    },
    setFaqCategoryList(state, payload) {
      state.faqCategoryList = payload;
    },
  },
  actions: {
    autoLogin({ commit }, payload) {
      return _integratedAxios
        .post(`/admin/auth/login?email=${payload.email}&idx=${payload.idx}`, {})
        .then(res => {
          const { success, data: respData } = res.data;
          const { accessToken, memberInfo } = respData;
          if (success) {
            commit('setAccessToken', accessToken);
            commit('setMemberInfo', memberInfo);
            return true;
          } else {
            return false;
          }
        })
        .catch(function (error) {
          if (error.response) {
            // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.

            console.error(error.response.data);
            console.error(error.response.status);
            console.error(error.response.headers);
          } else if (error.request) {
            // 요청이 이루어 졌으나 응답을 받지 못했습니다.
            // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
            // Node.js의 http.ClientRequest 인스턴스입니다.
            console.error(error.request);
          } else {
            // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
            console.error('Error', error.message);
          }
          console.log(error.config);
        });
    },
    apiHqManagerList({ commit }) {
      return _integratedAxios
        .get(`/admin/common/staff/list/0`, {})
        .then(data => {
          const { data: respData } = data;

          const { list } = respData.data;

          if (list.length > 0) {
            const temp = [];
            for (let i = 0; i < list.length; i++) {
              temp.push({
                value: list[i].idx,
                text: list[i].name,
                email: list[i].email,
              });
            }

            commit('setManager', temp);
          } else {
            commit('setManager', []);
          }
        })
        .catch(function (error) {
          if (error.response) {
            // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.

            console.error(error.response.data);
            console.error(error.response.status);
            console.error(error.response.headers);
          } else if (error.request) {
            // 요청이 이루어 졌으나 응답을 받지 못했습니다.
            // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
            // Node.js의 http.ClientRequest 인스턴스입니다.
            console.error(error.request);
          } else {
            // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
            console.error('Error', error.message);
          }
          console.log(error.config);
        });
    },
    apiTemaList({ commit }) {
      return _integratedAxios
        .get(`/admin/common/team/list`, {})
        .then(data => {
          const { data: respData } = data;
          const { list } = respData.data;

          if (list.length > 0) {
            const temp = [];
            for (let i = 0; i < list.length; i++) {
              temp.push({
                value: list[i].idx,
                text: list[i].teamName,
              });
            }

            commit('setTeamList', temp);
          } else {
            commit('setTeamList', []);
          }
        })
        .catch(function (error) {
          if (error.response) {
            // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.

            console.error(error.response.data);
            console.error(error.response.status);
            console.error(error.response.headers);
          } else if (error.request) {
            // 요청이 이루어 졌으나 응답을 받지 못했습니다.
            // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
            // Node.js의 http.ClientRequest 인스턴스입니다.
            console.error(error.request);
          } else {
            // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
            console.error('Error', error.message);
          }
          console.log(error.config);
        });
    },
    apiTemplateList({ commit }) {
      return _integratedAxios
        .get('/admin/common/template/list', {})
        .then(data => {
          const { data: respData } = data;
          const { list } = respData.data;

          if (list.length > 0) {
            const temp = [];
            for (let i = 0; i < list.length; i++) {
              temp.push({
                value: list[i].idx,
                text: list[i].templateName,
              });
            }
            commit('setTemplateList', temp);
          } else {
            commit('setTemplateList', []);
          }
        })
        .catch(function (error) {
          if (error.response) {
            // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
            console.error(error.response.data);
            console.error(error.response.status);
            console.error(error.response.headers);
          } else if (error.request) {
            // 요청이 이루어 졌으나 응답을 받지 못했습니다.
            // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
            // Node.js의 http.ClientRequest 인스턴스입니다.
            console.error(error.request);
          } else {
            // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
            console.error('Error', error.message);
          }
          console.log(error.config);
          commit('setTemplateList', []);
        });
    },
    apiFaqCategoryList({ commit }) {
      _integratedAxios
        .get('/admin/common/faq-category/list', {})
        .then(resp => {
          const { success, data: respData } = resp.data;
          if (success) {
            const { list } = respData;
            //20230130 - ITM은 현재 보류 이므로 필터링 처리
            const filList = list.filter(item => item.idx !== 99);

            if (filList.length > 0) {
              const temp = [];
              for (let i = 0; i < filList.length; i++) {
                temp.push({
                  value: filList[i].idx,
                  text: filList[i].categoryName,
                });
              }
              commit('setFaqCategoryList', temp);
            }
          }
        })
        .catch(function (error) {
          if (error.response) {
            // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
            console.error(error.response.data);
            console.error(error.response.status);
            console.error(error.response.headers);
          } else if (error.request) {
            // 요청이 이루어 졌으나 응답을 받지 못했습니다.
            // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
            // Node.js의 http.ClientRequest 인스턴스입니다.
            console.error(error.request);
          } else {
            // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
            console.error('Error', error.message);
          }
          console.log(error.config);
          commit('setFaqCategoryList', []);
        });
    },
  },

  plugins: [persistedStateVuex.init],
});
